import {
    filterOnlyMatchingTagId, filterOnlyMatchingBatterTagId,
} from './byParameterValue.js';
import { filterOnlyHavingParameterSet } from './byParameterName.js';
import { buildPitchScoringFilters } from './byContext.js';
import { buildTaggingFiltersForHittingChart } from './hittingChartsFilters.js';

const buildFiltersForGenericChart = function({
        // tagging context
        batterIds, pitchResults, pitchTypes, zones, pitcherIds, pitcherHandedness,
        // scoring context
        outs, balls, strikes, runnersOn,
    }, requireHit
){
    let batterTagIds = batterIds || [];

    let hittingChartFilters = [];
    const taggingFilters = buildTaggingFiltersForHittingChart({ pitchResults, pitchTypes, zones, pitcherIds, pitcherHandedness });
    if (taggingFilters instanceof Array){
        hittingChartFilters = hittingChartFilters.concat(taggingFilters);
    }

    const scoringFilters = buildPitchScoringFilters({ outs, balls, strikes, runnersOn });
    if (scoringFilters instanceof Array){
        hittingChartFilters = hittingChartFilters.concat(scoringFilters);
    }
    
    let batterIdFilter = [];
    if (requireHit) {
        if ((batterTagIds instanceof Array && batterTagIds.length) || batterTagIds > 0) {
            batterIdFilter = filterOnlyMatchingTagId(batterTagIds);
        }

        batterIdFilter.forEach(filter => filter.parameter = ['hit'].concat(filter.parameter));
        batterIdFilter = filterOnlyHavingParameterSet('hit').concat(batterIdFilter);
    }
    else if((batterTagIds instanceof Array && batterTagIds.length) || batterTagIds > 0) {
        hittingChartFilters = hittingChartFilters.concat(filterOnlyMatchingBatterTagId(batterTagIds));
    }
    
    if (hittingChartFilters.length) {
        hittingChartFilters.forEach(filter => filter.parameter = ['pitch'].concat(filter.parameter));
        hittingChartFilters = filterOnlyHavingParameterSet('pitch').concat(hittingChartFilters);
    }

    return batterIdFilter.concat(hittingChartFilters);
};

export default buildFiltersForGenericChart;
export {
    buildFiltersForGenericChart
};